var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge font-size-12 text-uppercase",class:_vm.config.cls},[_vm._v(_vm._s(_vm.config.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }